<div class="feedback-nav">
    <ol>
        <li class="version-nav-ico" *ngFor="let feedback of feedbacks; index as i;"
            [ngClass]="{
                'selected' : feedback.version.id == versionSelected.id,
                'approved' : feedback.approval != null && feedback.approval.status_code == APPROVAL_APPROVED && seeApprovalStatus,
                'rejected' : feedback.approval != null && feedback.approval.status_code == APPROVAL_REJECTED && seeApprovalStatus
            }">
            <core-version-preview-title
                [title]="'version '+ feedback.version.version"
                [version]="feedback.version" (clickSelect)="onClickItem($event)"
            ></core-version-preview-title>
            <!-- <core-versions-thumbnail-item
                [version]="feedback.version" (clickSelect)="onClickItem($event)"
            ></core-versions-thumbnail-item> -->
        </li>
    </ol>
</div>
